//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    listsData: {
      type: Object,
      required: false
    },
    moreClass: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      arrow: require("@/assets/image/icon/arrow.png")
    };
  },
  methods: {
    gotoMore() {
      // console.log(this.listsData);
      // alert(JSON.stringify(this.listsData.columnCode))
      let obj = {
        path: this.UTILS.splitUrl(this.listsData.jumpUrl),
        router: this.$router,
        query: {
          code: this.listsData.pageCode,
          title: this.listsData.pageName
        }
      };
      this.GLOBAL_.ccApp.openTo(obj);

    }
  }
};



// WEBPACK FOOTER //
// ./src/components/block/components/footMore.vue